import { APIService } from '../api';
import { ChatMessageStatus } from './ChatMessageStatus';
import { Model } from './Model';
import { HasMany, HasOne, Relations } from './Relations';
import { User } from './User';

export enum ChatMessageState {
    SENDING = 'sending',
    FAIL = 'fail',
    SENT = 'sent',
    READ = 'read',
}

export enum ChatMeChatMessageState {}

export class ChatMessage extends Model implements Relations<ChatMessage> {
    public readonly blueprint = ChatMessage;
    public readonly endpoint = APIService.createLambdaEndpoint('chat/rooms/{room_id}/messages/{message_id}');

    public relations() {
        return [HasOne('sender', User, ChatMessage), HasMany('statuses', ChatMessageStatus, ChatMessage)];
    }

    public sender_id!: number;

    public state!: ChatMessageState;
    public room_id!: number;
    public message!: string;
    public platform!: string;
    public format!: string;

    public extra!: Record<string, any>;

    public sender!: User;
    public statuses!: ChatMessageStatus[];

    private setState(state: ChatMessageState) {
        this.state = state;
        return this;
    }

    public sending() {
        return this.setState(ChatMessageState.SENDING);
    }

    public failToSend() {
        return this.setState(ChatMessageState.FAIL);
    }

    public isReadBy(user_id: number) {
        return this.getStatusOf(user_id)?.isRead() ?? false;
    }

    public getStatusOf(user_id: number): ChatMessageStatus | null {
        return this.statuses?.find((status) => status.user_id === user_id) ?? null;
    }

    public isReceived(): boolean {
        if (!this.statuses || this.statuses.length === 0) {
            return false;
        }

        for (const status of this.statuses) {
            if (!status.isReceived()) {
                return false;
            }
        }

        return true;
    }

    public isRead(): boolean {
        if (!this.statuses || this.statuses.length === 0) {
            return false;
        }

        for (const status of this.statuses) {
            if (!status.isRead()) {
                return false;
            }
        }

        return true;
    }
}
